module.exports = __webpack_public_path__ + "img/Mao2.03069b43.png";